"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationReason = void 0;
var CancellationReason;
(function (CancellationReason) {
    CancellationReason["ClaimFilingDateNotRespected"] = "01";
    CancellationReason["Financial"] = "02";
    CancellationReason["WithdrawnByLender"] = "03";
    CancellationReason["PaymentPreviouslyMade"] = "04";
    CancellationReason["LenderNegligenceMisrepresentation"] = "05";
    CancellationReason["TitleDefect"] = "06";
    CancellationReason["NoAmountPayable"] = "07";
    CancellationReason["PolicyNotInForce"] = "08";
    CancellationReason["SupplementaryClaimReceivedIsLessThan$250"] = "11";
    CancellationReason["AssignmentOfMortgageNoAttemptAtSaleOfProperty"] = "13";
    CancellationReason["InputError"] = "14";
})(CancellationReason = exports.CancellationReason || (exports.CancellationReason = {}));
